import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import OnboardingWizard from "./components/OnboardingWizard";
import Dashboard from "./pages/Dashboard";
import AttackWheel from "./pages/AttackWheel";
import DefenseWheel from "./pages/DefenseWheel";
import PenaltiesWheel from "./pages/PenaltiesWheel";
import CustomWheels from "./pages/CustomWheels";
import ObjectivesGenerator from "./pages/ObjectivesGenerator";
import StreamingMode from "./pages/StreamingMode";
import ContentManagement from "./pages/ContentManagement";
import HistoryPage from "./pages/HistoryPage";
import OBSEditor from "./pages/OBSEditor";
import StreamDeckGuide from "./pages/StreamDeckGuide";
import SettingsPage from "./pages/SettingsPage";
import OBSOverlay from "./pages/OBSOverlay";

function AdminApp() {
  return (
    <>
      <OnboardingWizard />
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/attack" element={<AttackWheel />} />
          <Route path="/defense" element={<DefenseWheel />} />
          <Route path="/objectives" element={<ObjectivesGenerator />} />
          <Route path="/penalties" element={<PenaltiesWheel />} />
          <Route path="/custom" element={<CustomWheels />} />
          <Route path="/streaming" element={<StreamingMode />} />
          <Route path="/content" element={<ContentManagement />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route path="/overlay-editor" element={<OBSEditor />} />
          <Route path="/stream-deck" element={<StreamDeckGuide />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </Layout>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/overlay" element={<OBSOverlay filterMode="all" />} />
          <Route path="/overlay/wheel" element={<OBSOverlay filterMode="wheel" />} />
          <Route path="/overlay/objective" element={<OBSOverlay filterMode="objective" />} />
          <Route path="/overlay/:kind" element={<OBSOverlay />} />
          <Route path="/*" element={<AdminApp />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
